import React, { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Typography, Button } from '@mui/material';

// project imports

import { useDispatch } from 'store';

// assets

const avatarImage = require.context('assets/images/users', true);

// ==============================|| USER LIST 1 ||============================== //

const FavoriteList = ({ isLoading, clipData, clipItem, getCouponsList, rowsPerPage, setRowsPerPage, page, setPage, handleDeleteClip }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  // console.log('clipData', clipData);

  const [data1, setData1] = React.useState(clipData);
  // const [page, setPage] = React.useState(0);
  const [loading, setLoading] = useState(true);
  // const [rowsPerPage, setRowsPerPage] = React.useState(5);
  // const { usersS1 } = useSelector((state) => state.user);

  //   const ConvertJST = (time) => {
  //     time = new Date(time);
  //     time.setHours(time.getHours() + 9);
  //     return time.toLocaleString().slice(0, -3);
  //   };

  // const ConvertJST = (utcTimestamp) => {
  //   const date = new Date(utcTimestamp * 1000);

  //   // JSTにフォーマットして出力
  //   const options = {
  //     timeZone: 'Asia/Tokyo', // 日本標準時
  //     year: 'numeric',
  //     month: '2-digit',
  //     day: '2-digit',
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     second: '2-digit'
  //   };

  //   return new Intl.DateTimeFormat('ja-JP', options).format(date);
  // };

  // 使用例
  //   const utcTimestamp = Date.now();
  //   console.log(convertUTCToJST(utcTimestamp)); // JSTの日付表記

  const handleChangePage = (event, newPage) => {
    // console.log('handleChangePage', newPage);
    // console.log(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    // console.log(event.target.value);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const data = React.useMemo(
  //   () => couponsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
  //   [page, rowsPerPage, couponsData]
  // );

  // const data = couponsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // const data = data1.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // React.useEffect(() => {
  //   console.log('start useEffect');
  //   setData1(couponsData);
  //   console.log('end useEffect');
  // }, [couponsData]);

  return (
    <Box>
      <TableContainer>
        <Table>
          <TableHead sx={{ whiteSpace: 'nowrap' }}>
            <TableRow key="tableHead">
              <TableCell sx={{ pl: 3 }}>#</TableCell>
              {/* <TableCell>couponsName</TableCell>
                            <TableCell>subtitle</TableCell> */}
              <TableCell>記事タイトル</TableCell>
              <TableCell>記事画像</TableCell>
              <TableCell align="center">操作</TableCell>
              {/* <TableCell>保存日時</TableCell> */}
              {/* <TableCell>金額</TableCell> */}
              {/* <TableCell>status</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {clipData &&
              clipData.map((row, index) => (
                <TableRow
                  hover
                  key={row.c_id}
                  onClick={() => {
                    window.open(row.post_url, '_blank'); // 新しいタブでリンクを開く
                  }}
                >
                  <TableCell sx={{ pl: 3 }}>{index + 1}</TableCell>
                  {/* <TableCell>
                                        <Typography align="left" variant="subtitle1">
                                            {row.name}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography align="left" variant="subtitle1">
                                            {row.subtitle}
                                        </Typography>
                                    </TableCell> */}
                  <TableCell>
                    <Typography align="left" variant="subtitle1">
                      {/* {ConvertJST(row.captured_at)} */}
                      {row.post_title}
                    </Typography>
                  </TableCell>
                  {/* <TableCell>
                    <Typography align="left" variant="subtitle1">
                      {row.endAt}
                    </Typography>
                  </TableCell> */}
                  <TableCell>
                    <img src={row.thumbnail_url} width="80" height="80" alt={row.post_title} style={{ objectFit: 'contain' }} />
                  </TableCell>
                  <TableCell align="center">
                    <Button variant="contained" color="error" onClick={(e) => handleDeleteClip(e, row)}>
                      削除
                    </Button>
                  </TableCell>
                  <TableCell>
                    {/* <Typography align="left" variant="subtitle1">
                      ￥{row.amount}
                    </Typography> */}
                  </TableCell>

                  {/*  <TableCell><EditCoupuns row={row} getCouponsLst={getCouponsList} /></TableCell> */}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={clipItem?.total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default FavoriteList;
